import type { JSX } from "react";

import { Flex, Group, Loader, Text } from "@mantine/core";

import type { CustomerLocationViewProps } from "./CustomerLocation.types";

import { LocationIcon } from "./LocationIcon";

export function CustomerLocationView({
    locationText,
    formattedTime,
    isTimezoneLoading,
}: CustomerLocationViewProps): JSX.Element {
    return (
        <Flex align="center" gap="xs" data-testid="customer-location">
            <LocationIcon />
            <Group gap="3xs">
                <Text fz="sm" c="dark.0" data-testid="customer-location-text">
                    {locationText}
                </Text>
                {isTimezoneLoading ? (
                    <Loader size="xs" color="dark.3" type="dots" />
                ) : formattedTime ? (
                    <Text fz="sm" c="dark.0">
                        {` • ${formattedTime}`}
                    </Text>
                ) : null}
            </Group>
        </Flex>
    );
}
